import {Button} from '@logistics-frontend/blocks'
import React from 'react'

import {Props} from './CloseButton.types'

const Base: React.FC<Props> = ({onClick, text}) => (
  // @ts-expect-error требуется рефактор чтобы хендлер не юзал ивент
  <Button onClick={onClick} textVariant="body2" variant="ghost" fullWidth>
    {text}
  </Button>
)

export const CloseButton = React.memo(Base)
